import parseWithDate from 'json.date-extensions'
const STORAGE_KEY = 'korAccountEntries_redux'

export const loadState=() => {
    try{
        const serializedState = localStorage.getItem(STORAGE_KEY);
        if(serializedState === null){
            return undefined;
        }
        return  {entryReducer: JSON.parseWithDate(serializedState) };
    }
    catch (err){
        return undefined;
    }
};

export const saveState = (state) => {
    try{
        const serializedState = JSON.stringify(state);
        localStorage.setItem(STORAGE_KEY, serializedState);
    }
    catch(err){
        //TODO:
    }
}